import { render, staticRenderFns } from "./ExpertComment.vue?vue&type=template&id=6a25f94e&scoped=true"
import script from "./ExpertComment.vue?vue&type=script&lang=js"
export * from "./ExpertComment.vue?vue&type=script&lang=js"
import style0 from "./ExpertComment.vue?vue&type=style&index=0&id=6a25f94e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a25f94e",
  null
  
)

export default component.exports